import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCMKo3g0U4_Tt-RykA7cC5INv_vW-X_4dI",
  authDomain: "loveallbadminton.firebaseapp.com",
  projectId: "loveallbadminton",
  storageBucket: "loveallbadminton.firebasestorage.app",
  messagingSenderId: "684786940550",
  appId: "1:684786940550:web:7dc2a3f491b783d5beaf07",
  measurementId: "G-W0GTD7P7QD"
};

// Initialize Firebase (singleton)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

let messagingInstance = null;

function getMessagingInstance() {
  if (!messagingInstance && typeof window !== 'undefined' && 'Notification' in window) {
    try {
      messagingInstance = getMessaging(app);
    } catch (e) {
      console.warn('[Firebase] Messaging not supported:', e.message);
    }
  }
  return messagingInstance;
}

/**
 * Request notification permission and get FCM token
 * @param {string} vapidKey - VAPID key from Firebase Console > Cloud Messaging
 * @returns {Promise<string|null>} FCM token or null
 */
export async function requestNotificationPermission(vapidKey) {
  if (!('Notification' in window)) {
    console.warn('[Firebase] Notifications not supported in this browser');
    return null;
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    console.warn('[Firebase] Notification permission denied');
    return null;
  }

  const messaging = getMessagingInstance();
  if (!messaging) return null;

  try {
    // Wait for service worker registration
    const swRegistration = await navigator.serviceWorker.ready;
    
    const token = await getToken(messaging, {
      vapidKey: vapidKey,
      serviceWorkerRegistration: swRegistration,
    });
    
    console.log('[Firebase] FCM Token obtained');
    return token;
  } catch (error) {
    console.error('[Firebase] Error getting FCM token:', error);
    return null;
  }
}

/**
 * Listen for foreground messages
 * @param {Function} callback - Called with {title, body, data} when message arrives
 * @returns {Function} Unsubscribe function
 */
export function onForegroundMessage(callback) {
  const messaging = getMessagingInstance();
  if (!messaging) return () => {};

  return onMessage(messaging, (payload) => {
    console.log('[Firebase] Foreground message:', payload);
    callback({
      title: payload.notification?.title || 'LoveAll',
      body: payload.notification?.body || '',
      data: payload.data || {},
    });
  });
}

export { app };
